import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard-2" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'
import { stroke } from "@/core/data/dashboards"
import { useDashboardStore } from "@/store/dashboard"

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexEcommerce',
  setup(__props) {

const SalesAnalytics = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/SalesAnalytics.vue"))
const UserStatus = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/UserStatus.vue"))
const SelesView = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/SelesView.vue"))
const SellingProducts = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/SellingProducts.vue"))
const StokeSell = defineAsyncComponent(() => import("@/components/common/StokeSell.vue"))
const BestSeller = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/BestSeller.vue"))
const SellingRate = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/SellingRate.vue"))
const SwiperSlide = defineAsyncComponent(() => import("@/components/common/SwiperSlide.vue"))
const ActivityTimeline = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/ActivityTimeline.vue"))
const OurTarget = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/OurTarget.vue"))
const RecentOrders = defineAsyncComponent(() => import("@/components/theme/dashboards/ecommerce/RecentOrders.vue"))
let store = useDashboardStore()
let swipers = store.swiperss

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Dashboard",
      ecommorcedesc: "true",
      mains: "Ecommerce dashboard",
      title: "Ecommerce"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(SalesAnalytics)),
        _createVNode(_unref(UserStatus)),
        _createVNode(_unref(SelesView)),
        _createVNode(_unref(SellingProducts)),
        _createVNode(_unref(StokeSell), {
          height: "153",
          mainClass: "col-xxl-3 col-xl-4 col-md-5 box-col-4",
          colClass: "col-sm-6 col-md-12",
          data: _unref(stroke)
        }, null, 8, ["data"]),
        _createVNode(_unref(BestSeller)),
        _createVNode(_unref(SellingRate)),
        _createVNode(_unref(SwiperSlide), {
          colClass: "col-xxl-3 col-xl-4 col-sm-6 box-col-6",
          data: _unref(swipers)
        }, null, 8, ["data"]),
        _createVNode(_unref(ActivityTimeline)),
        _createVNode(_unref(OurTarget)),
        _createVNode(_unref(RecentOrders))
      ])
    ])
  ], 64))
}
}

})